module.exports = __webpack_public_path__ + "img/l_hk.bc140f23.png";